import { Injectable } from "@angular/core";
import { Environment } from "../environment.interface";
@Injectable()
export class EnvironmentService {
     public settings!: Environment;
}
